import { createActions } from 'redux-actions'

import { defaultFilter, defaultPage } from './defaultState'

export const {
  company: {
    jobs: {
      load: loadCompanyJobs,
      loadSuccess: loadCompanyJobsSuccess,
      loadFailure: loadCompanyJobsFailure,
      setFilter: setCompanyJobsFilter,
      init: initCompanyJobs
    }
  }
} = createActions({
  COMPANY: {
    JOBS: {
      LOAD: ({ companyId, page = defaultPage, filter = defaultFilter }) => ({ companyId, page, filter }),
      LOAD_SUCCESS: [({ items, page, hasMorePages }) => ({ items, page, hasMorePages }), (payload, { companyId }) => ({ companyId })],
      LOAD_FAILURE: message => ({ message }),
      SET_FILTER: ({ companyId, filter }) => ({ companyId, filter }),
      INIT: (companyId) => ({ companyId })
    }
  }
})
